
import React from 'react';
import { BookingCard } from './BookingCard';
import type { Tables } from '@/integrations/supabase/types';

interface BookingsListProps {
  bookings: Tables<'booking_details'>[];
  loading: boolean;
  isUpcoming: boolean;
  formatDate: (dateString: string) => string;
  formatCurrency: (amount: number) => string;
}

export const BookingsList: React.FC<BookingsListProps> = ({ 
  bookings, 
  loading, 
  isUpcoming, 
  formatDate, 
  formatCurrency 
}) => {
  if (loading) {
    return <div className="py-10 text-center text-muted-foreground">Loading bookings...</div>;
  }

  if (bookings.length === 0) {
    return (
      <div className="py-10 text-center text-muted-foreground">
        {isUpcoming 
          ? 'No upcoming bookings. Click "New" to create one.' 
          : 'No past bookings found.'}
      </div>
    );
  }

  return (
    <>
      {bookings.map((booking, index) => (
        <BookingCard
          key={booking.id || index}
          booking={booking}
          index={index}
          isUpcoming={isUpcoming}
          formatDate={formatDate}
          formatCurrency={formatCurrency}
        />
      ))}
    </>
  );
};
